import request from '@/utils/request'
import qs from 'qs'
import {
	getCookie
} from '@/utils/cookiejs'

//登录
export function login(data) {
	return request({
		url: '/api/oauth/CustomerLogin',
		method: 'post',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		data: qs.stringify(data)
	})
}

//登出
export function Logout() {
	return request({
		url: '/api/oauth/Logout',
		method: 'get',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

//获取当前登录客户信息
export function GetCurrCustomer() {
	return request({
		url: '/api/crm/Customer/GetCurrCustomer',
		method: 'get',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

//修改客户信息
export function UpdateCustomerDetail(data) {
	return request({
		url: '/api/crm/Customer/Detail',
		method: 'put',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

//注册校验
export function RegisterCheck(email) {
	return request({
		url: '/api/crm/Register/RegisterCheck?email=' + email,
		method: 'get'
	})
}

//客户注册
export function Register(data) {
	return request({
		url: '/api/crm/Register',
		method: 'post',
		data: data
	})
}

//客户激活
export function Activate(customerId) {
	return request({
		url: `/api/crm/Register/Activate/${customerId}`,
		method: 'post',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

//客户激活邮件
export function SendActivateEmail(customerId) {
	return request({
		url: '/api/system/messagetemplate/SendActivationEmail?customerId=' + customerId,
		method: 'post'
	})
}

//忘记密码邮件
export function SendFogetPwdEmail(email) {
	return request({
		url: '/api/system/messagetemplate/SendFogetPwdEmail?email=' + email,
		method: 'post'
	})
}

//获取客户地址
export function GetCustomerAddress(data) {
	return request({
		url: '/api/crm/Address/GetCustomerAddress',
		method: 'get',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

//删除客户地址
export function DeleteCustomerAddress(id) {
	return request({
		url: `/api/crm/Address/${id}`,
		method: 'delete',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

//获取客户商品
export function GetCustomerCommodity() {
	return request({
		url: `/api/crm/CustomerCommodity`,
		method: 'get',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

//获取客户商品详情
export function GetCommodityDetail(id) {
	return request({
		url: `/api/crm/CustomerCommodity/${id}`,
		method: 'get',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

//创建客户商品
export function CreateCustomerCommodity(data) {
	return request({
		url: `/api/crm/CustomerCommodity`,
		method: 'post',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

//修改客户商品
export function UpdateCustomerCommodity(data) {
	return request({
		url: `/api/crm/CustomerCommodity`,
		method: 'put',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

//删除客户商品
export function DeleteCustomerCommodity(id) {
	return request({
		url: `/api/crm/CustomerCommodity/${id}`,
		method: 'delete',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

//重置密码
export function ResetPassword(data) {
	return request({
		url: `api/permission/Users/Current/Actions/ResetPasswordEn`,
		method: 'post',
		data: data,
		headers: {
			'Authorization': data.resetToken
		}
	})
}

//获取当前用户所有账户
export function GetUserList() {
	return request({
		url: `/api/crm/user/Customer`,
		method: 'get',
		headers: {
			'Authorization':getCookie('token')
		}
	})
}

//修改用户状态
export function DisableEnable(id) {
	return request({
		url: `/api/crm/user/DisableEnable/${id}`,
		method: 'post',
		headers: {
			'Authorization':getCookie('token')
		}
	})
}

//查询用户详情
export function GetUser(id) {
	return request({
		url: `/api/crm/user/CustomerDetail/${id}`,
		method: 'get',
		headers: {
			'Authorization':getCookie('token')
		}
	})
}

//新增用户
export function CreateUser(data) {
	return request({
		url: `/api/crm/user/CreateUser`,
		method: 'post',
		data: data,
		headers: {
			'Authorization':getCookie('token')
		}
	})
}

//修改用户
export function UpdateUser(data) {
	return request({
		url: `/api/crm/user/UpdateUser`,
		method: 'put',
		data: data,
		headers: {
			'Authorization':getCookie('token')
		}
	})
}

//导出客户订单
export function ExportShipment(data) {
	return request({
		url: `api/shipping/PersonOrder/Export`,
		method: 'get',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

//导出客户账单
export function ExportBill(data) {
	return request({
		url: `api/fin/FinancialCosts/Export`,
		method: 'get',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

//导出客户账单详情
export function ExportBillDetail(data) {
	return request({
		url: `api/fin/FinancialCosts/ExportBillDetail`,
		method: 'get',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

//导出客户账单详情
export function GetChatUserId() {
	return request({
		url: `api/webapi/user/GetChatUserId`,
		method: 'get',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}